// Types
import type {
	TTabActive,
	TTabListProps,
	TTabPanelListProps,
	TTabPanelProps,
	TTabPanelSlideDirection,
	TTabPosition, TTabsProps
} from './Tabs.type';

export const TAB_DISPLAY_NAME = 'Tab';
export const TAB_LIST_DISPLAY_NAME = 'TabList';
export const TAB_PANEL_DISPLAY_NAME = 'TabPanel';
export const TAB_PANEL_LIST_DISPLAY_NAME = 'TabPanelList';
export const TABS_CHILDREN_DISPLAY_NAME = [
	TAB_LIST_DISPLAY_NAME,
	TAB_PANEL_LIST_DISPLAY_NAME
];

/*
 This is the default timeout for the TabPanel transition to be opened / closed.
 The timeout value is in milliseconds.
 If this timeout is changed please also change the variable $timeout in './style.module.scss'
 To prevent any race between the collapse animation and the disposal of the TabPanel component, please add 100ms more value than the timeout value in css.
 Recommended value: 400ms
 */
export const TAB_PANEL_TIMEOUT = 400;

export const TAB_PANEL_SLIDE_DIRECTION: { [key in TTabPanelSlideDirection]: key } = {
	right: 'right',
	left: 'left'
}

export const TABS_POSITIONS: TTabPosition[] = ['top', 'right', 'bottom', 'left'];
export const TABS_POSITION: { [key in TTabPosition]: key } = {
	top: 'top',
	right: 'right',
	bottom: 'bottom',
	left: 'left'
}

export const TAB_DEFAULT_PROPS = {
	position: TABS_POSITION.top,
}

export const TAB_ACTIVE_STYLE_DEFAULT: TTabActive = {
	index: 0
};

export const UNKNOWN_TAB_ACTIVE: TTabActive = {
	index: -1,
	width: 0,
	height: 0,
}

export const TAB_LIST_DEFAULT_PROPS: TTabListProps = {
	activeTab: 0,
	position: TABS_POSITION.top
}

export const TAB_PANEL_DEFAULT_PROPS: TTabPanelProps = {
	slideDirection: TAB_PANEL_SLIDE_DIRECTION.left
}

export const TAB_PANEL_LIST_DEFAULT_PROPS: TTabPanelListProps = {
	activePanel: 0
}

export const TABS_DEFAULT_PROPS: TTabsProps = {
	activeTab: 0,
	position: TABS_POSITION.top
}
